"use client";

import { CompanyProvider } from "@/lib/company-context";
import { RegisterForm } from "@/components/auth/auth-forms";

export default function RegisterPage() {
  return (
    <CompanyProvider>
      <RegisterForm />
    </CompanyProvider>
  );
}
